var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgYoutube(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 16,
    viewBox: "0 0 22 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.4708 2.84699C21.2255 1.92316 20.5026 1.19559 19.5847 0.948672C17.9211 0.5 11.2499 0.5 11.2499 0.5C11.2499 0.5 4.57884 0.5 2.91513 0.948672C1.99728 1.19563 1.27438 1.92316 1.02903 2.84699C0.583252 4.52148 0.583252 8.01516 0.583252 8.01516C0.583252 8.01516 0.583252 11.5088 1.02903 13.1833C1.27438 14.1071 1.99728 14.8044 2.91513 15.0513C4.57884 15.5 11.2499 15.5 11.2499 15.5C11.2499 15.5 17.921 15.5 19.5847 15.0513C20.5026 14.8044 21.2255 14.1071 21.4708 13.1833C21.9166 11.5088 21.9166 8.01516 21.9166 8.01516C21.9166 8.01516 21.9166 4.52148 21.4708 2.84699ZM9.0681 11.1871V4.84316L14.6438 8.01523L9.0681 11.1871Z",
    fill: "#8C7C73"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.22bebe92.svg";
export { ForwardRef as ReactComponent };